export default __webpack_public_path__ + "static/disk-b8b421451d2470a20235d79d7a65326b.png";